import { Component, OnInit, Input, Injectable } from '@angular/core';
import { Articulo } from '../../models/articulo.model';
import { PedidoService } from '../../services/pedido.service';
import { environment } from '../../../environments/environment';
import { ArticuloPropWidgetComponent } from "../articulo-prop-widget/articulo-prop-widget.component";
import { TipoBultoPipe } from "../../services/tipo-bulto.pipe";
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-articulo-cesta',
  templateUrl: './articulo-cesta.component.html',
  styleUrls: ['./articulo-cesta.component.scss'],
  imports: [ArticuloPropWidgetComponent, TipoBultoPipe, CommonModule]
})

export class ArticuloCestaComponent implements OnInit {
  @Input() articulo!: Articulo;
  @Input() modo!: string;

  // https://asg-gemmasales.asg-si.net/gemmasales/datos/img/art/thumbs/{{articulo.referencia}}.png
  IMG_URL = environment.SERVER_IMG;
  IMG_EXTENSION = environment.IMG_EXTENSION;
  COMPRA_TB = environment.COMPRA_TB;
  TIPO_BULTO = environment.TIPO_BULTO;
  dia: Date;

  constructor(
    public pedidoService: PedidoService
  ) {
    this.dia = new Date();
    console.log(this.modo);
  }

  ngOnInit(): void {
  }

  compraMas(articulo: Articulo) {
    this.pedidoService.sumaCesta(articulo);
  }
  compraMenos(articulo: Articulo) {
    this.pedidoService.restaCesta(articulo);
  }
  compraCero(articulo: Articulo) {
    this.pedidoService.borraCesta(articulo);
  }

  cambiarCantidad(articulo: Articulo, cant: number) {
    this.pedidoService.cambiarCantidadCesta(articulo, cant);
  }

  verLogisticaInfo() {
    if (this.articulo.bulto_pvp === 'F') {
      return `Caja ${this.articulo.unid_caja / this.articulo.unid_frac}`;
    } else if (this.articulo.bulto_pvp === 'U') {
      if (this.articulo.unid_frac !== this.articulo.unid_caja) {
        return `Caja ${this.articulo.unid_caja}, Frac ${this.articulo.unid_frac}`;
      } else {
        return `Caja ${this.articulo.unid_caja}`;
      }
    }
    return 'Caja ';
  }

  classModo(clase: string) {
    console.log('${clase}-${this.modo}');
    return '${clase}-${this.modo}';
  }
  classSelUnid() {
    switch (this.articulo.pedcl_tb_ped) {
      case 'U':
        return 'caja-unid';
      case 'F':
        return 'caja-frac';
      case 'C':
        return 'caja-caja';
      case 'K':
        return 'caja-kilo';

      default:
        return 'caja-unid';
    }
    if (this.articulo.pedcl_tb_ped === 'U') {
      return 'btn-unid';
    }
    return 'btn-outline-primary';
  }

}
